import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {HttpLegacyService} from '../../../core/http/http-legacy.service';
import {GetQuestionsWithAnswersResponseModel, MosPostRequestPayloadModel} from '../models/mos-steps.models';
import {HttpService} from '../../../core/http/http.service';
import {
  BuyerPaymentNeededCheckResponse,
} from '../models/cc-payment.model';

@Injectable({
  providedIn: 'root'
})
export class MosService {

  ccPaymentDone = false;

  constructor(private httpLegacyService: HttpLegacyService,
              private httpService: HttpService) {
  }

  getQuestionsWithAnswers(groupId: number, userId: number, relatedId: number): Observable<GetQuestionsWithAnswersResponseModel> {
    return this.httpLegacyService.get(`v2/answers/group/${groupId}`, {
      user_id: userId,
      related_id: relatedId,
      related_type: 'offer'
    })
      .pipe(map((data: { data: GetQuestionsWithAnswersResponseModel }) => data.data));
  }

  postQuestionnaire(payload: MosPostRequestPayloadModel): Observable<null> {
    return this.httpLegacyService.postWithoutXSRF(`v1/questions/questionnaires`, payload)
      .pipe(map((data: null) => data));
  }

  verifyShouldBuyerDoAmlPayment(userId: number, propertyId: number): Observable<BuyerPaymentNeededCheckResponse> {
    return this.httpService.get(`api/buyer-payments/users/${userId}/properties/${propertyId}/payment-needed`)
      .pipe(map((data: { data: BuyerPaymentNeededCheckResponse }) => {
        return data.data;
      }));
  }

}
